<script lang="ts">
  import cx from "classnames";

  export let active: boolean;
  export let disabled = false;
  export let a11yLabel = "";
  let className = "";
  export { className as class };
</script>

<button
  aria-label={a11yLabel}
  on:click
  class={cx(
    "rounded p-1 px-2 hover:bg-black/10 hover:dark:bg-white/10",
    { "pointer-events-none cursor-not-allowed opacity-25": disabled },
    { "bg-black/5 dark:bg-white/5": active },
    className
  )}
  class:font-bold={active}
  type={"button"}
  {disabled}
>
  <slot />
</button>
